export default (theme) => ({
  form: {
    width: '100%',
  },
  input: {
    width: '100%',
    marginTop: 25,
    '&:first-of-type': {
      marginTop: 10,
    },
  },
  submit: {
    marginTop: 15,
    width: '100%',
    minHeight: 45,
  },
  codeWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  codeInput: {
    textTransform: 'capitalize',
    marginTop: 25,
    width: 'calc(100% - 160px)',
    [theme.breakpoints.down('sm')]: {
      width: 'calc(100% - 150px)',
    },
  },
  resendBtn: {
    marginTop: 30,
    height: 44,
    width: 140,
  },
});
